module.exports = __webpack_public_path__ + "img/cszq_banner_0.4787080d.png";